// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const fermentationAttributeDefinitionId = (z.number());
export const fermentationAttributeDefinition = z.object({
    id: fermentationAttributeDefinitionId,
    name: z.string(),
    display_name: z.string(),
    unit: z.string().nullable(),
    category: z.string().nullable(),
    decimal_places: z.number(),
    created_at: z.date().nullable(),
    color: z.string(),
    roleless: z.boolean(),
    quantity: z.string().nullable(),
});
export const fermentationAttributeDefinitionInitializer = z.object({
    id: fermentationAttributeDefinitionId.optional(),
    name: z.string(),
    display_name: z.string(),
    unit: z.string().optional().nullable(),
    category: z.string().optional().nullable(),
    decimal_places: z.number().optional(),
    created_at: z.date().optional().nullable(),
    color: z.string().optional(),
    roleless: z.boolean().optional(),
    quantity: z.string().optional().nullable(),
});
export const fermentationAttributeDefinitionMutator = z.object({
    id: fermentationAttributeDefinitionId.optional(),
    name: z.string().optional(),
    display_name: z.string().optional(),
    unit: z.string().optional().nullable(),
    category: z.string().optional().nullable(),
    decimal_places: z.number().optional(),
    created_at: z.date().optional().nullable(),
    color: z.string().optional(),
    roleless: z.boolean().optional(),
    quantity: z.string().optional().nullable(),
});
//# sourceMappingURL=FermentationAttributeDefinition.js.map